/* eslint-disable*/
import React from 'react'
import { useSelector } from 'react-redux';
import { selectUserData } from '../../Redux/UserSlice';
import wallet from '../../Assets/images/wallet.png';
import bookings from '../../Assets/images/booking.png';
import progress from '../../Assets/images/progress.png';
const Dashboard = () => {
    const userData = useSelector(selectUserData);

    return (
        <div>
            <div id="content">
                <div className="content-admin-main">
                    <div className="admin-top-area border-0 shadow-bx d-flex flex-wrap justify-content-center m-b30 align-items-center">
                        <h2>User Dashboard</h2>
                    </div>
                    {/* <div className="admin-top-area d-flex flex-wrap justify-content-between m-b30 align-items-center">
                        <div className="admin-left-area">
                            <a
                                className="nav-btn-admin d-flex justify-content-between align-items-center"
                                id="sidebarCollapse"
                            >
                                <span className="nav-btn-text">Dashboard Menu</span>
                                <span className="fa fa-reorder" />
                            </a>
                        </div>
                        <div className="admin-area-mid">
                            <div className="admin-area-heading">
                                <span>Your Tariff Plan : </span>
                                <strong>
                                    Extended <i className="fa fa-caret-down" />
                                </strong>
                            </div>
                            <div className="admin-area-content">
                                you Are on Extended . Use link bellow to view details or upgrade.Details{" "}
                            </div>
                        </div>
                        <div className="admin-right-area">
                            <div className="pro-pic-info-wrap d-flex">
                                <div className="pro-pic-box">
                                    <img src="images/user.jpg" alt="" />
                                </div>
                                <div className="pro-pic-info">
                                    <strong>David Wood</strong>
                                    <span>Designer</span>
                                </div>
                                <span className="feather-icon has-toltip">
                                    <i className="feather-power" />
                                    <span className="header-toltip">Notification</span>
                                </span>
                            </div>
                        </div>
                    </div> */}
                    <div className="row">
                        <div className="col-xl-8 col-lg-12 m-b30 break-1300">
                            <div className="card aon-card">
                                <div className="card-body aon-card-body">
                                    <div className="row">
                                        <div className="col-lg-4 m-b30">
                                            <div className="panel panel-default ser-card-default">
                                                <div className="panel-body ser-card-body ser-puple p-a30">
                                                    <div className="ser-card-title">Wallet</div>
                                                    <div className="ser-card-icons">
                                                        <img src={wallet} alt="" />
                                                    </div>
                                                    <div className="ser-card-amount">$252.45</div>
                                                    <div className="ser-card-table">
                                                        <div className="ser-card-left">
                                                            <div className="ser-card-total">
                                                                <div className="ser-total-table">
                                                                    <div className="ser-total-cell1">Total</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="ser-card-right">
                                                            <div className="ser-card-icon">
                                                                <i className="glyph-icon flaticon-money-3" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span className="ser-card-circle-bg" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 m-b30">
                                            <div className="panel panel-default ser-card-default">
                                                <div className="panel-body ser-card-body ser-orange p-a30">
                                                    <div className="ser-card-title">Booking</div>
                                                    <div className="ser-card-icons">
                                                        <img src={bookings} alt="" />
                                                    </div>
                                                    <div className="ser-card-amount">465</div>
                                                    <div className="ser-card-table">
                                                        <div className="ser-card-left">
                                                            <div className="ser-card-total">
                                                                <div className="ser-total-table">
                                                                    <div className="ser-total-cell1">Wallet</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="ser-card-right">
                                                            <div className="ser-card-icon">
                                                                <i className="glyph-icon flaticon-wallet" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span className="ser-card-circle-bg" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 m-b30">
                                            <div className="panel panel-default ser-card-default">
                                                <div className="panel-body ser-card-body ser-blue p-a30">
                                                    <div className="ser-card-title">Earning</div>
                                                    <div className="ser-card-icons">
                                                        <img src={wallet} alt="" />
                                                    </div>
                                                    <div className="ser-card-amount">$124.00</div>
                                                    <div className="ser-card-table">
                                                        <div className="ser-card-left">
                                                            <div className="ser-card-total">
                                                                <div className="ser-total-table">
                                                                    <div className="ser-total-cell1">Complete</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="ser-card-right">
                                                            <div className="ser-card-icon">
                                                                <i className="glyph-icon flaticon-calendar" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span className="ser-card-circle-bg" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-12 m-b30 break-1300">
                            <div className="card aon-card">
                                <div className="card-header aon-card-header aon-card-header2">
                                    <h4>
                                        <i className="fas fa-timeline" /> Booking Stats
                                    </h4>
                                </div>
                                <div className="card-body aon-card-body">
                                    <div>
                                        <ul className="list-unstyled">
                                            <li className="py-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-xs rounded-circle bg-primary-subtle m-r10">
                                                        <i className="fa fas fa-thumbs-up text-success" />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <p className="text-muted mb-2">Completed</p>
                                                        <div className="progress progress-sm animated-progess">
                                                            <div
                                                                className="progress-bar bg-success"
                                                                role="progressbar"
                                                                style={{ width: "70%" }}
                                                                aria-valuenow={70}
                                                                aria-valuemin={0}
                                                                aria-valuemax={100}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="py-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-xs rounded-circle m-r10 bg-warning-subtle">
                                                        {/* <i className="fa fab fa-pied-piper-alt" /> */}
                                                        <img src={progress} alt="" width={'30px'} />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <p className="text-muted mb-2">In Progress</p>
                                                        <div className="progress progress-sm animated-progess">
                                                            <div
                                                                className="progress-bar bg-warning"
                                                                role="progressbar"
                                                                style={{ width: "45%" }}
                                                                aria-valuenow={45}
                                                                aria-valuemin={0}
                                                                aria-valuemax={100}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="py-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-xs align-self-center ">
                                                        <div className="avatar-xs rounded-circle bg-danger-subtle m-r10">
                                                            <i className="fa fas fa-ban text-danger" />
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <p className="text-muted mb-2">Cancel</p>
                                                        <div className="progress progress-sm animated-progess">
                                                            <div
                                                                className="progress-bar bg-danger"
                                                                role="progressbar"
                                                                style={{ width: "19%" }}
                                                                aria-valuenow={19}
                                                                aria-valuemin={0}
                                                                aria-valuemax={100}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <hr />
                                    <div className="text-center">
                                        <div className="row aon-states-row">
                                            <div className="col-4">
                                                <div className="mt-2">
                                                    <p className="text-muted mb-2">Completed</p>
                                                    <h5 className="font-size-16 mb-0">70</h5>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="mt-2">
                                                    <p className="text-muted mb-2">Pending</p>
                                                    <h5 className="font-size-16 mb-0">45</h5>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="mt-2">
                                                    <p className="text-muted mb-2">Cancel</p>
                                                    <h5 className="font-size-16 mb-0">99</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-8 m-b30">
                            {/* <div className="card aon-card">
                                <div className="card-header aon-card-header aon-card-header2">
                                    <h4>
                                        <i className="feather-pie-chart" /> Booking
                                    </h4>
                                </div>
                                <div className="card-body aon-card-body">
                                    <div className="dx-viewport demo-container dx-device-desktop dx-device-generic">
                                        <div id="chart-demo">
                                            <div id="chart" className="dx-visibility-change-handler">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    version="1.1"
                                                    fill="none"
                                                    stroke="none"
                                                    strokeWidth={0}
                                                    className="dxc dxc-chart"
                                                    width={620}
                                                    height={420}
                                                    style={{
                                                        lineHeight: "normal",
                                                        userSelect: "none",
                                                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                                        display: "block",
                                                        overflow: "hidden"
                                                    }}
                                                    direction="ltr"
                                                >
                                                    <defs>
                                                        <filter
                                                            id="DevExpress_1"
                                                            x="-50%"
                                                            y="-50%"
                                                            width="200%"
                                                            height="200%"
                                                            transform="translate(0,0)"
                                                        >
                                                            <feGaussianBlur
                                                                in="SourceGraphic"
                                                                result="gaussianBlurResult"
                                                                stdDeviation={3}
                                                            />
                                                            <feOffset
                                                                in="gaussianBlurResult"
                                                                result="offsetResult"
                                                                dx={2}
                                                                dy={6}
                                                            />
                                                            <feFlood
                                                                result="floodResult"
                                                                floodColor=""
                                                                floodOpacity="0.8"
                                                            />
                                                            <feComposite
                                                                in="floodResult"
                                                                in2="offsetResult"
                                                                operator="in"
                                                                result="compositeResult"
                                                            />
                                                            <feComposite
                                                                in="SourceGraphic"
                                                                in2="compositeResult"
                                                                operator="over"
                                                            />
                                                        </filter>
                                                        <clipPath id="DevExpress_2">
                                                            <rect
                                                                x={0}
                                                                y={0}
                                                                width={620}
                                                                height={420}
                                                                transform="translate(0,0)"
                                                            />
                                                        </clipPath>
                                                        <clipPath id="DevExpress_4">
                                                            <rect
                                                                x={24}
                                                                y={8}
                                                                width={596}
                                                                height={386}
                                                                transform="translate(0,0)"
                                                            />
                                                        </clipPath>
                                                        <clipPath id="DevExpress_5">
                                                            <rect
                                                                x={24}
                                                                y={8}
                                                                width={596}
                                                                height={386}
                                                                transform="translate(0,0)"
                                                            />
                                                        </clipPath>
                                                    </defs>
                                                    <rect
                                                        x={0}
                                                        y={0}
                                                        width={620}
                                                        height={420}
                                                        transform="translate(0,0)"
                                                        fill="gray"
                                                        opacity="0.0001"
                                                    />
                                                    <g className="dxc-background" />
                                                    <g className="dxc-strips-group">
                                                        <g
                                                            className="dxc-val-strips"
                                                            clipPath="url(#DevExpress_4)"
                                                        />
                                                        <g
                                                            className="dxc-arg-strips"
                                                            clipPath="url(#DevExpress_4)"
                                                        />
                                                    </g>
                                                    <g className="dxc-grids-group">
                                                        <g className="dxc-val-grid">
                                                            <path
                                                                d="M 24 394 L 620 394"
                                                                transform="translate(0,-0.5)"
                                                                stroke="#d3d3d3"
                                                                strokeWidth={1}
                                                                opacity={1}
                                                            />
                                                            <path
                                                                d="M 24 339 L 620 339"
                                                                transform="translate(0,0.5)"
                                                                stroke="#d3d3d3"
                                                                strokeWidth={1}
                                                                opacity={1}
                                                            />
                                                            <path
                                                                d="M 24 284 L 620 284"
                                                                transform="translate(0,0.5)"
                                                                stroke="#d3d3d3"
                                                                strokeWidth={1}
                                                                opacity={1}
                                                            />
                                                            <path
                                                                d="M 24 229 L 620 229"
                                                                transform="translate(0,0.5)"
                                                                stroke="#d3d3d3"
                                                                strokeWidth={1}
                                                                opacity={1}
                                                            />
                                                            <path
                                                                d="M 24 174 L 620 174"
                                                                transform="translate(0,0.5)"
                                                                stroke="#d3d3d3"
                                                                strokeWidth={1}
                                                                opacity={1}
                                                            />
                                                            <path
                                                                d="M 24 118 L 620 118"
                                                                transform="translate(0,0.5)"
                                                                stroke="#d3d3d3"
                                                                strokeWidth={1}
                                                                opacity={1}
                                                            />
                                                            <path
                                                                d="M 24 63 L 620 63"
                                                                transform="translate(0,0.5)"
                                                                stroke="#d3d3d3"
                                                                strokeWidth={1}
                                                                opacity={1}
                                                            />
                                                            <path
                                                                d="M 24 8 L 620 8"
                                                                transform="translate(0,0.5)"
                                                                stroke="#d3d3d3"
                                                                strokeWidth={1}
                                                                opacity={1}
                                                            />
                                                        </g>
                                                        <g className="dxc-arg-grid" />
                                                    </g>
                                                    <g className="dxc-border" />
                                                    <g className="dxc-axes-group">
                                                        <g
                                                            className="dxc-val-axis"
                                                            transform="translate(0,0)"
                                                            clipPath="url(#DevExpress_2)"
                                                        >
                                                            <g className="dxc-val-line">
                                                                <path
                                                                    d="M 24 394 L 24 8"
                                                                    transform="translate(0.5,0)"
                                                                    strokeWidth={1}
                                                                    stroke="#767676"
                                                                />
                                                                <path
                                                                    d="M 18 394 L 25 394"
                                                                    transform="translate(0,-0.5)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 18 339 L 25 339"
                                                                    transform="translate(0,0.5)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 18 284 L 25 284"
                                                                    transform="translate(0,0.5)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 18 229 L 25 229"
                                                                    transform="translate(0,0.5)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 18 174 L 25 174"
                                                                    transform="translate(0,0.5)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 18 118 L 25 118"
                                                                    transform="translate(0,0.5)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 18 63 L 25 63"
                                                                    transform="translate(0,0.5)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 18 8 L 25 8"
                                                                    transform="translate(0,0.5)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                            </g>
                                                            <g className="dxc-val-title" />
                                                        </g>
                                                        <g
                                                            className="dxc-arg-axis"
                                                            transform="translate(0,0)"
                                                            clipPath="url(#DevExpress_2)"
                                                        >
                                                            <g className="dxc-arg-line">
                                                                <path
                                                                    d="M 24 394 L 620 394"
                                                                    transform="translate(0,-0.5)"
                                                                    strokeWidth={1}
                                                                    stroke="#767676"
                                                                />
                                                                <path
                                                                    d="M 43 393 L 43 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 62 393 L 62 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 82 393 L 82 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 101 393 L 101 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 120 393 L 120 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 139 393 L 139 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 159 393 L 159 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 178 393 L 178 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 197 393 L 197 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 216 393 L 216 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 235 393 L 235 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 255 393 L 255 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 274 393 L 274 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 293 393 L 293 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 312 393 L 312 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 332 393 L 332 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 351 393 L 351 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 370 393 L 370 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 389 393 L 389 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 409 393 L 409 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 428 393 L 428 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 447 393 L 447 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 466 393 L 466 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 485 393 L 485 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 505 393 L 505 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 524 393 L 524 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 543 393 L 543 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 562 393 L 562 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 582 393 L 582 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                                <path
                                                                    d="M 601 393 L 601 400"
                                                                    transform="translate(0.5,0)"
                                                                    stroke="#767676"
                                                                    strokeWidth={1}
                                                                    opacity={1}
                                                                />
                                                            </g>
                                                            <g className="dxc-arg-title" />
                                                        </g>
                                                    </g>
                                                    <g className="dxc-strips-labels-group">
                                                        <g className="dxc-val-axis-labels" />
                                                        <g className="dxc-arg-axis-labels" />
                                                    </g>
                                                    <g className="dxc-constant-lines-group">
                                                        <g className="dxc-val-constant-lines" />
                                                        <g
                                                            className="dxc-val-constant-lines"
                                                            transform="translate(0,0)"
                                                        />
                                                        <g
                                                            className="dxc-val-constant-lines"
                                                            transform="translate(0,0)"
                                                        />
                                                        <g className="dxc-arg-constant-lines" />
                                                        <g
                                                            className="dxc-arg-constant-lines"
                                                            transform="translate(0,0)"
                                                        />
                                                        <g
                                                            className="dxc-arg-constant-lines"
                                                            transform="translate(0,0)"
                                                        />
                                                    </g>
                                                    <g className="dxc-series-group">
                                                        <g className="dxc-series">
                                                            <g
                                                                fill="#1db2f5"
                                                                stroke="#1db2f5"
                                                                strokeWidth={0}
                                                                className="dxc-markers"
                                                                opacity={1}
                                                                transform="translate(0,0) scale(1,1)"
                                                            >
                                                                <rect
                                                                    x={27}
                                                                    y={91}
                                                                    width={13}
                                                                    height={302}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                />
                                                                <rect
                                                                    x={46}
                                                                    y={201}
                                                                    width={13}
                                                                    height={192}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                />
                                                                <rect
                                                                    x={65}
                                                                    y={229}
                                                                    width={13}
                                                                    height={164}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                />
                                                                <rect
                                                                    x={84}
                                                                    y={174}
                                                                    width={13}
                                                                    height={219}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                />
                                                                <rect
                                                                    x={104}
                                                                    y={201}
                                                                    width={13}
                                                                    height={192}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                />
                                                                <rect
                                                                    x={123}
                                                                    y={201}
                                                                    width={13}
                                                                    height={192}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                />
                                                                <rect
                                                                    x={142}
                                                                    y={91}
                                                                    width={13}
                                                                    height={302}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                />
                                                                <rect
                                                                    x={161}
                                                                    y={146}
                                                                    width={13}
                                                                    height={247}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                />
                                                                <rect
                                                                    x={238}
                                                                    y={146}
                                                                    width={13}
                                                                    height={247}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                />
                                                                <rect
                                                                    x={219}
                                                                    y={229}
                                                                    width={13}
                                                                    height={164}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                />
                                                                <rect
                                                                    x={257}
                                                                    y={174}
                                                                    width={13}
                                                                    height={219}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                />
                                                                <rect
                                                                    x={277}
                                                                    y={229}
                                                                    width={13}
                                                                    height={164}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                />
                                                                <rect
                                                                    x={315}
                                                                    y={229}
                                                                    width={13}
                                                                    height={164}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                />
                                                                <rect
                                                                    x={373}
                                                                    y={63}
                                                                    width={13}
                                                                    height={330}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                />
                                                                <rect
                                                                    x={411}
                                                                    y={174}
                                                                    width={13}
                                                                    height={219}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                />
                                                                <rect
                                                                    x={450}
                                                                    y={146}
                                                                    width={13}
                                                                    height={247}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                />
                                                                <rect
                                                                    x={488}
                                                                    y={229}
                                                                    width={13}
                                                                    height={164}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                />
                                                                <rect
                                                                    x={507}
                                                                    y={91}
                                                                    width={13}
                                                                    height={302}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    strokeWidth={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                />
                                                                <rect
                                                                    x={180}
                                                                    y={256}
                                                                    width={13}
                                                                    height={137}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={200}
                                                                    y={174}
                                                                    width={13}
                                                                    height={219}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={296}
                                                                    y={229}
                                                                    width={13}
                                                                    height={164}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={334}
                                                                    y={118}
                                                                    width={13}
                                                                    height={275}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={353}
                                                                    y={146}
                                                                    width={13}
                                                                    height={247}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={392}
                                                                    y={146}
                                                                    width={13}
                                                                    height={247}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={430}
                                                                    y={36}
                                                                    width={13}
                                                                    height={357}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={469}
                                                                    y={201}
                                                                    width={13}
                                                                    height={192}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={526}
                                                                    y={174}
                                                                    width={13}
                                                                    height={219}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={546}
                                                                    y={201}
                                                                    width={13}
                                                                    height={192}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={565}
                                                                    y={146}
                                                                    width={13}
                                                                    height={247}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#a2b5e7"
                                                                    stroke="#a2b5e7"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={584}
                                                                    y={201}
                                                                    width={13}
                                                                    height={192}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#ffb600"
                                                                    stroke="#ffb600"
                                                                    strokeWidth={0}
                                                                />
                                                                <rect
                                                                    x={603}
                                                                    y={311}
                                                                    width={13}
                                                                    height={82}
                                                                    transform="translate(0,0)"
                                                                    rx={0}
                                                                    ry={0}
                                                                    fill="#022279"
                                                                    stroke="#022279"
                                                                    strokeWidth={0}
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                    <g className="dxc-elements-axes-group">
                                                        <g
                                                            className="dxc-val-elements"
                                                            transform="translate(0,0)"
                                                            clipPath="url(#DevExpress_2)"
                                                        >
                                                            <text
                                                                x={24}
                                                                y={394}
                                                                transform="translate(-14,5)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                0
                                                            </text>
                                                            <text
                                                                x={24}
                                                                y={339}
                                                                transform="translate(-14,5)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                2
                                                            </text>
                                                            <text
                                                                x={24}
                                                                y={284}
                                                                transform="translate(-14,5)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                4
                                                            </text>
                                                            <text
                                                                x={24}
                                                                y={229}
                                                                transform="translate(-14,5)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                6
                                                            </text>
                                                            <text
                                                                x={24}
                                                                y={174}
                                                                transform="translate(-14,5)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                8
                                                            </text>
                                                            <text
                                                                x={24}
                                                                y={118}
                                                                transform="translate(-17,5)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                10
                                                            </text>
                                                            <text
                                                                x={24}
                                                                y={63}
                                                                transform="translate(-17,5)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                12
                                                            </text>
                                                            <text
                                                                x={24}
                                                                y={8}
                                                                transform="translate(-17,5)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                14
                                                            </text>
                                                        </g>
                                                        <g
                                                            className="dxc-arg-elements"
                                                            transform="translate(0,0)"
                                                            clipPath="url(#DevExpress_2)"
                                                        >
                                                            <text
                                                                x={34}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                1
                                                            </text>
                                                            <text
                                                                x={53}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                2
                                                            </text>
                                                            <text
                                                                x={72}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                3
                                                            </text>
                                                            <text
                                                                x={91}
                                                                y={394}
                                                                transform="translate(0.5,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                4
                                                            </text>
                                                            <text
                                                                x={111}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                5
                                                            </text>
                                                            <text
                                                                x={130}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                6
                                                            </text>
                                                            <text
                                                                x={149}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                7
                                                            </text>
                                                            <text
                                                                x={168}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                8
                                                            </text>
                                                            <text
                                                                x={187}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                9
                                                            </text>
                                                            <text
                                                                x={207}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                10
                                                            </text>
                                                            <text
                                                                x={226}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                11
                                                            </text>
                                                            <text
                                                                x={245}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                12
                                                            </text>
                                                            <text
                                                                x={264}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                13
                                                            </text>
                                                            <text
                                                                x={284}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                14
                                                            </text>
                                                            <text
                                                                x={303}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                15
                                                            </text>
                                                            <text
                                                                x={322}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                16
                                                            </text>
                                                            <text
                                                                x={341}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                17
                                                            </text>
                                                            <text
                                                                x={360}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                18
                                                            </text>
                                                            <text
                                                                x={380}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                19
                                                            </text>
                                                            <text
                                                                x={399}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                20
                                                            </text>
                                                            <text
                                                                x={418}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                21
                                                            </text>
                                                            <text
                                                                x={437}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                22
                                                            </text>
                                                            <text
                                                                x={457}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                23
                                                            </text>
                                                            <text
                                                                x={476}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                24
                                                            </text>
                                                            <text
                                                                x={495}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                25
                                                            </text>
                                                            <text
                                                                x={514}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                26
                                                            </text>
                                                            <text
                                                                x={533}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                27
                                                            </text>
                                                            <text
                                                                x={553}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                28
                                                            </text>
                                                            <text
                                                                x={572}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                29
                                                            </text>
                                                            <text
                                                                x={591}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                30
                                                            </text>
                                                            <text
                                                                x={610}
                                                                y={394}
                                                                transform="translate(0,23)"
                                                                textAnchor="middle"
                                                                style={{
                                                                    whiteSpace: "pre",
                                                                    fill: "rgb(118, 118, 118)",
                                                                    fontFamily:
                                                                        '"Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif',
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    cursor: "default"
                                                                }}
                                                            >
                                                                31
                                                            </text>
                                                        </g>
                                                    </g>
                                                    <g className="dxc-constant-lines-group">
                                                        <g className="dxc-val-constant-lines" />
                                                        <g
                                                            className="dxc-val-constant-lines"
                                                            transform="translate(0,0)"
                                                        />
                                                        <g
                                                            className="dxc-val-constant-lines"
                                                            transform="translate(0,0)"
                                                        />
                                                        <g className="dxc-arg-constant-lines" />
                                                        <g
                                                            className="dxc-arg-constant-lines"
                                                            transform="translate(0,0)"
                                                        />
                                                        <g
                                                            className="dxc-arg-constant-lines"
                                                            transform="translate(0,0)"
                                                        />
                                                    </g>
                                                    <g className="dxc-scale-breaks" />
                                                    <g className="dxc-labels-group">
                                                        <g
                                                            className="dxc-labels"
                                                            pointerEvents="none"
                                                            clipPath="url(#DevExpress_5)"
                                                            transform="translate(0,0)"
                                                        />
                                                    </g>
                                                    <g className="dxc-crosshair-cursor" />
                                                    <g className="dxc-legend" clipPath="url(#DevExpress_2)" />
                                                    <g className="dxc-annotations" />
                                                </svg>
                                            </div>
                                            <div className="action">
                                                <div className="label">
                                                    Choose a temperature threshold, °C:{" "}
                                                </div>
                                                <div
                                                    id="choose-temperature"
                                                    className="dx-show-invalid-badge dx-selectbox dx-textbox dx-texteditor dx-dropdowneditor-button-visible dx-editor-outlined dx-widget dx-dropdowneditor dx-dropdowneditor-field-clickable"
                                                >
                                                    <div className="dx-dropdowneditor-input-wrapper dx-selectbox-container">
                                                        <input type="hidden" defaultValue={2} />
                                                        <div className="dx-texteditor-container">
                                                            <div className="dx-texteditor-input-container">
                                                                <input
                                                                    autoComplete="off"
                                                                    className="dx-texteditor-input"
                                                                    aria-haspopup="listbox"
                                                                    aria-autocomplete="list"
                                                                    type="text"
                                                                    readOnly=""
                                                                    spellCheck="false"
                                                                    tabIndex={0}
                                                                    role="combobox"
                                                                    aria-expanded="false"
                                                                />
                                                                <div
                                                                    data-dx_placeholder="Select..."
                                                                    className="dx-placeholder dx-state-invisible"
                                                                />
                                                            </div>
                                                            <div className="dx-texteditor-buttons-container">
                                                                <div />
                                                                <div
                                                                    className="dx-widget dx-button-mode-contained dx-button-normal dx-dropdowneditor-button"
                                                                    aria-label="Select"
                                                                    role="button"
                                                                >
                                                                    <div className="dx-button-content">
                                                                        <div className="dx-dropdowneditor-icon" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="col-xl-4">

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Dashboard
